import React from "react";

interface ChevronLeftProps {
  color?: string;
  className?: string;
}

const ChevronLeft: React.FC<ChevronLeftProps> = ({ color , className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`h-6 w-6 ${className}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke={color}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 19l-7-7 7-7"
      />
    </svg>
  );
};

export default ChevronLeft;
